import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=73a63f56&"
import script from "./TreeViewItem.vue?vue&type=script&lang=js&"
export * from "./TreeViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports